import {
  Component, OnInit, QueryList, Input, ViewEncapsulation,
  ViewChildren, ViewChild, Inject, ChangeDetectorRef, HostListener, OnChanges, ElementRef, AfterViewInit, SimpleChanges
} from '@angular/core';
import { ProductsService } from "../../../../Common/Services/products.service";
import {IVariantGroupingType} from "../../../../Common/Interfaces/IVariantGroupingType";
import { environment } from "../../../../Common/environments/environment";
import {ICategoryBrowseFilterOptions} from "../../../../Common/Interfaces/ICategoryBrowseFilterOptions";
import {ActivatedRoute} from "@angular/router";
import * as _ from 'lodash';
import {GeneralHelpers} from "../../../../Common/helpers/general.helper";
import {TitleCasePipe} from "@angular/common";
import VanillaScrollspy from '../../../../../../../src/js/Widgets/HanScrollSpy.js';
import * as smoothscroll from "smoothscroll-polyfill";
//declare var VanillaScrollspy: any;
let cachedOffset;



@Component({
  selector: 'kws-section-navigation-basic',
  templateUrl: './section-navigation-basic.component.html',
  encapsulation: ViewEncapsulation.None
})
export class SectionNavigationBasicComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() type: string;
  @Input() subtype: string;
  @Input() variantGroupingTypes: IVariantGroupingType[];
  @Input() variantGroupingTypesSingle: IVariantGroupingType;
  @Input() cat: string;
  @Input() groupBy: string;
  @Input() displayType: string;
  @Input() secondaryCat: string;
  @ViewChild('samePageNav') samePageNav: ElementRef;
  @ViewChild('dropButton') dropButton: ElementRef;
  @ViewChildren('tabParentDomElement') tabParentDomElement: QueryList<ElementRef>;
  staticSections: any = [];
  productListingUrl: string;
  activeTab: number = 0;
  isOpen: boolean = false;
  tabkey: string = "tab";
  afterCheckIndex: number = 0;
  variantGroupingsLength: number;
  flag: number = 0;
  slugifiedCategory: string;
  highlightedTab: number = 0;
  staticSectionsHeights: number = 0;
  browseAllLabel: string;


  constructor(private route: ActivatedRoute, private cd: ChangeDetectorRef, public titlecase: TitleCasePipe, private elementRef: ElementRef, public productsService: ProductsService) {
    this.route = route;

  }

  ngOnInit() {
    this.slugifyCategory();
    this.browseAllLabel = this.secondaryCat ? this.secondaryCat : this.cat;
    this.browseAllLabel = this.browseAllLabel.split('-').join(' ');
    this.productListingUrl = `${environment.serviceBaseUrl}/products/category/${this.slugifiedCategory}`;
    this.addStaticContentSections();
    smoothscroll.polyfill();

    let samePageNav = document.querySelector('#samePageNav');
    let scrollspy = new VanillaScrollspy(samePageNav);
    scrollspy.init();

    for (let i = 0; i < this.staticSections.length; i++) {
      this.staticSectionsHeights += parseInt(this.staticSections[i].height);
    }

    this.getNavOffset();
    console.log(this.staticSectionsHeights);
  }

  ngAfterViewInit(){
    //setup our scroll event listener
    window.addEventListener('scroll', this.onScroll(this.flag));

    //subscribe to changes on tabParentDomElement so we get the full array length after static sections are added
    this.tabParentDomElement.changes.subscribe(() => {
      this.tabParentDomElement.toArray().map(x => x.nativeElement);

      let config = { attributes: true, childList: true, subtree: true };
      let observer = new MutationObserver(this.mutationObserverCallback);
      this.tabParentDomElement.forEach(function(tabItem, index){
        observer.observe(tabItem.nativeElement, config);
      });
    });
  }

  //CALLBACK WHEN THE MUTATION OBSERVER COMES BACK AS CHANGED
  mutationObserverCallback(mutationsList, observer) {
    for(let mutation of mutationsList) {
      if (mutation.type == 'attributes') {
        if(mutation.target.classList.contains('same-page-nav__item--selected')) {
          let index = GeneralHelpers.indexInParent(mutation.target);
          this.activeTab = index;
        }
      }
    }
  }

  slugifyCategory() {
    if (this.secondaryCat) {
      this.slugifiedCategory = GeneralHelpers.ensureUnique(GeneralHelpers.slugify(this.secondaryCat));
    } else {
      this.slugifiedCategory = GeneralHelpers.ensureUnique(GeneralHelpers.slugify(this.cat));
    }
  }

  setTab(index, elem?) {
    this.activeTab = index;
    //if on mobile device
    if(document.documentElement.clientWidth < 992) {
      let buttonClicked = document.querySelector('.js-drop-button');
      buttonClicked.classList.toggle('same-page-nav__btn-drop--open');
      buttonClicked.textContent = elem.textContent;
      this.isOpen = !this.isOpen;
    }
  }

  //TOGGLES CLASS IN NAV
  toggleClass(e){
    e.preventDefault();
    this.isOpen = !this.isOpen;
  }

  isSmartKeyPadlocksNavItem(label: string) {
    return !!label && label.replace(/\s+/g, ' ').trim().toLowerCase() === 'smartkey padlocks';
  }

  //GETS ALL STATIC SECTIONS AND ADDS THEM TO THE NAV
  addStaticContentSections(){
    let sections = document.querySelectorAll('.container-as-nav-item');
    let sectionArray =  Array.from(sections);

    sectionArray.forEach(section => {
        let label = section.getAttribute('data-placeholder-label');
        let uniqueLabel = GeneralHelpers.ensureUnique(GeneralHelpers.slugify(label));
        section.setAttribute('id', uniqueLabel);
        this.staticSections.push({title: label, slug: uniqueLabel, height: section.clientHeight });
      });
  }

  getNavOffset(){
    let angularNav = document.getElementById('angular-nav').offsetTop;
    function reportWindowSize(){
      cachedOffset = angularNav;
    }

    cachedOffset = angularNav;
    window.addEventListener('resize', reportWindowSize);
  }


  //FUNCTION RUNS ONSCROLL
  onScroll(flag) {
    let $this = this;
    return function(){
      let scrollPos = window.pageYOffset || document.documentElement.scrollTop;
      let navElementSelector = document.documentElement.clientWidth < 992 ? document.querySelector('.js-drop-button') : document.querySelector('.same-page-nav__item');
      let stickyElement = document.querySelector(".fixedsticky");
      let stickyElementDesktop = document.querySelector(".fixedsticky-desktop");
      let samePageNav = document.getElementById('angular-nav');
      let filterBarContainer = document.getElementById('filterbarbasic');

      //SCROLL SPY WILL DISABLE THE FIRST ITEM IF IT GOES BACK TO THE OP OF THE PAGE PREVENT THIS FROM HAPPENING
      if(scrollPos >= cachedOffset) {
        if(flag === 0) {
          flag++;
        }
      } else {
        flag = 0;
        $this.activeTab = 0;
        if(!document.getElementsByClassName('same-page-nav__item--selected').length) {
          document.querySelector('.same-page-nav__item').classList.add('same-page-nav__item--selected');
        }
      }

      //IE11 Fix
      if(navigator.userAgent.indexOf('MSIE')!==-1 || navigator.appVersion.indexOf('Trident/') > -1){
       (function(){
         if(scrollPos > (cachedOffset + (filterBarContainer.offsetHeight - samePageNav.offsetHeight - 1))) {
           stickyElementDesktop.classList.add('hidden');
         } else {
           stickyElementDesktop.classList.remove('hidden');
         }

         if(scrollPos > cachedOffset) {
              stickyElement.classList.add('fixedsticky-on');
              stickyElement.classList.remove('fixedsticky-off');
              stickyElementDesktop.classList.add('fixedsticky-on');
              stickyElementDesktop.classList.remove('fixedsticky-off');
            } else {
              stickyElement.classList.add('fixedsticky-off');
              stickyElement.classList.remove('fixedsticky-on');
              stickyElementDesktop.classList.add('fixedsticky-off');
              stickyElementDesktop.classList.remove('fixedsticky-on');
            }
        }());
      }

      //Mobile Only
      if(document.documentElement.clientWidth < 992) {
        let link = document.querySelector('.same-page-nav__item--selected').children[0];
        if(navElementSelector.textContent !== link.textContent) {
          navElementSelector.textContent = link.textContent;
        }
      }
    };
  }

  //WHEN NAV ITEMS IS CLICKED SMOOTH SCROLL DOWN TO WHERE IT SHOULD GO (WITH OFFSETS FOR NAV AT DESKTOP AND MOBILE)
  slideToView(element, event){
    event.preventDefault();
    let samePageNav = GeneralHelpers.getClosest(element,'.js-same-page-nav-nav');
    let targetId = element.getAttribute('href').split('#')[1];
    let target = document.getElementById(targetId);
    let offsetAddition  = document.documentElement.clientWidth < 992 ? 45 : 55;
    let top;
    if(navigator.userAgent.indexOf('MSIE')!==-1 || navigator.appVersion.indexOf('Trident/') > -1){
      console.log('got here');
      if(document.getElementById('angular-nav').classList.contains('fixedsticky-on')) {
        console.log('stickynav is on');
        top = target.offsetTop - offsetAddition;
      } else {
        console.log('stickynav is off');
        top = (target.offsetTop - 134) - offsetAddition;
      }
    } else {
      top = target.offsetTop - offsetAddition;
    }

    console.log(top);
    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  }

  ngOnChanges(){
    if (this.tabParentDomElement && this.tabParentDomElement.length) {
      let i = 0;
      this.tabParentDomElement.forEach(el => {
        if (el.nativeElement.classList.contains('same-page-nav__item--selected')) {
          this.activeTab = i;
          return;
        }
        i++;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/ts/Apps/CategoryBrowsing/src/app/section-navigation/section-navigation-basic.component.ts